const InputWarning = ({ text = '' }) => (
  <p style={{ fontWeight: 500, fontSize: '24px', gridArea: 'warning' }}>
    {text}
  </p>
);

export default InputWarning;
